import { createRoute, lazyRouteComponent, type AnyRoute } from "@tanstack/react-router";
import { z } from "zod";

const listSearch = z.object({
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(10).max(200).optional(),
  q: z.string().optional(),
  status: z.string().optional(),
  direction: z.string().optional(),
  documentType: z.string().optional(),
  tradingPartnerId: z.coerce.number().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  view: z.string().optional(),
  tab: z.string().optional(),
}).passthrough();

export function portalRoutes(parent: AnyRoute): AnyRoute[] {
  const r = (path: string, load: () => Promise<{ default: React.ComponentType }>, opts: { search?: boolean } = {}) =>
    createRoute({
      getParentRoute: () => parent,
      path,
      component: lazyRouteComponent(load),
      ...(opts.search ? { validateSearch: (s: Record<string, unknown>) => listSearch.parse(s) } : {}),
    });

  return [
    r("/", () => import("./pages/home.tsx")),
    r("/documents", () => import("./pages/documents.tsx"), { search: true }),
    r("/documents/$id", () => import("./pages/document-detail.tsx"), { search: true }),
    r("/upload", () => import("./pages/upload.tsx")),
    r("/returns", () => import("./pages/returns.tsx"), { search: true }),
    r("/shipments", () => import("./pages/shipments.tsx"), { search: true }),
    r("/shipments/$id", () => import("./pages/shipment.tsx"), { search: true }),
    r("/partners", () => import("./pages/partners.tsx"), { search: true }),
    r("/partners/new", () => import("./pages/partner-setup.tsx"), { search: true }),
    r("/partners/$id", () => import("./pages/partner-setup.tsx"), { search: true }),
    r("/products", () => import("./pages/products.tsx"), { search: true }),
    r("/people", () => import("./pages/people.tsx"), { search: true }),
    r("/connections", () => import("./pages/connections.tsx"), { search: true }),
    r("/api-access", () => import("./pages/api-access.tsx"), { search: true }),
    r("/reports", () => import("./pages/reports.tsx"), { search: true }),
    r("/notifications", () => import("./pages/notifications.tsx"), { search: true }),
    r("/feedback", () => import("./pages/feedback.tsx")),
    r("/help", () => import("./pages/help.tsx")),
    r("/help/asn", () => import("../shared/pages/help-asn.tsx")),
    r("/account", () => import("../shared/pages/account.tsx"), { search: true }),
  ];
}
